  document.addEventListener('DOMContentLoaded', function() {
    const tooltipIcon = document.querySelector('.tooltip-icon');
    const tooltipContent = document.querySelector('.tooltip-content');

    if (tooltipIcon && tooltipContent) {
      const tooltipText = tooltipIcon.getAttribute('data-tooltip');
      tooltipContent.innerHTML = tooltipText;

      // Mostrar tooltip al pasar el ratón
      tooltipIcon.addEventListener('mouseenter', function() {
        tooltipContent.style.opacity = '1';
        tooltipContent.style.visibility = 'visible';
      });

      // Ocultar tooltip al salir del ratón
      tooltipIcon.addEventListener('mouseleave', function() {
        tooltipContent.style.opacity = '0';
        tooltipContent.style.visibility = 'hidden';
      });

      // Mantener visible si el ratón está sobre el tooltip
      tooltipContent.addEventListener('mouseenter', function() {
        this.style.opacity = '1';
        this.style.visibility = 'visible';
      });

      tooltipContent.addEventListener('mouseleave', function() {
        this.style.opacity = '0';
        this.style.visibility = 'hidden';
      });
    }
  });